import { render, staticRenderFns } from "./Branchname.vue?vue&type=template&id=a3737eee&scoped=true"
import script from "./Branchname.vue?vue&type=script&lang=js"
export * from "./Branchname.vue?vue&type=script&lang=js"
import style0 from "./Branchname.vue?vue&type=style&index=0&id=a3737eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3737eee",
  null
  
)

export default component.exports